import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { SupplierOrders } from 'src/app/models/supplier-portal/supplier/supplierOrders.models';
import { OrderSupplierService } from 'src/app/services/portal-supplier/order-supplier.service';
import { ManufacturerPopoversService } from 'src/app/services/shared/manufacturer-popovers.service';

@Component({
  selector: 'app-partial',
  standalone: false,
  templateUrl: './partial.component.html',
  styleUrls: ['./partial.component.scss'],
})
export class PartialComponent implements OnInit {
  @Input() accountId: number = null;
  @Output() orderProcessed = new EventEmitter<void>();
  loading: boolean = false;
  public readonly pageSize = 20;
  public readonly rowHeight = 44;

  public Order: SupplierOrders.IOrder[] = [];
  private readonly orderSupplierService = inject(OrderSupplierService);
  private readonly mServ = inject(ManufacturerPopoversService);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit() {
    this.getList();
  }

  public getList() {
    if (!this.accountId) {
      return;
    }
    this.orderSupplierService
      .getSupplier(this.accountId)
      .subscribe((result) => {
        const supplierId = result?.supplier?.supplier_id;
        if (!supplierId) {
          return;
        }
        this.orderSupplierService
          .getPartialCertifications(supplierId)
          .subscribe((ordersResult) => {
            this.Order = ordersResult?.data?.partial_orders ?? [];
            this.loading = false;
            this.cdr.detectChanges();
            this.orderSupplierService.orderNumberCounter.next(
              this.Order.length,
            );
          });
      });
  }

  public processOrder(order: SupplierOrders.IOrder): void {
    const supplierAccount = this.orderSupplierService.suplierDetails;
    const payload: SupplierOrders.IAddNewOrderFromGamma = {
      supplier_id: supplierAccount?.supplier?.supplier_id,
      supplier_code: supplierAccount?.supplier?.code,
      order_number: order.order_number,
    };

    this.orderSupplierService.addNewOrder(payload).subscribe((response) => {
      if (!response) {
        this.mServ.serverErrorSwal();
        return;
      }
      if (response?.error_message?.msg_code == 0) {
        this.mServ.addedOrderSwal();
        this.orderProcessed.emit();
      } else if (response?.error_message?.msg_code == 8) {
        this.mServ.noOrderFoundSwal();
      } else {
        this.mServ.serverErrorSwal();
      }
    });
  }

  public formatArticleCount(articles: number): string {
    return new Intl.NumberFormat('it-IT').format(articles).replace(/,/g, "'");
  }

  public getProgressColor(progress: number): string {
    if (progress >= 50) return '#1692ff';
    if (progress >= 25) return '#f5a623';
    return '#e41212';
  }

  public get gridHeight(): number {
    const minimumHeight = 164;
    const maximumHeight = 368;
    const headerHeight = 44;
    const gridChrome = 8;
    const visibleRows = Math.max(this.Order.length, 1);
    return Math.min(
      maximumHeight,
      Math.max(
        minimumHeight,
        headerHeight + visibleRows * this.rowHeight + gridChrome,
      ),
    );
  }
}
